<template>
    <div class="ui_hotelBook" :style="{ 'backgroundColor': datas.componentBgColor }">
        <div class="hotel_search" :style="{ width: 'calc(100% - ' + whiteSpace * 2 + 'px)' }"
            :class="{ 'shadow': datas.showShadow }">
            <div class="switchChannel" v-if="channels.length > 1 && loaded">
                <div class="channel" v-for="(channel, channelIndex) in channels" :key="channelIndex"
                    @click="changeChannel(channel, channelIndex)"
                    :class="{ 'active': currentChannelIndex == channelIndex }"
                    :style="{ 'color': currentChannelIndex == channelIndex ? datas.textColor : '' }">
                    {{ channel.name }}
                </div>
                <div class="selectChannel"
                    v-bind:class="{ third: channels.length == 3, left: currentChannelIndex != 0, right: currentChannelIndex != channels.length - 1 }"
                    :style="{
                        transform: `translateX(${100 * (currentChannelIndex * 1)}%)`
                    }"></div>
            </div>
            <div class="rowWrapper" v-bind:class="{ radius: channels.length == 1 && loaded }">
                <div class="row oneline">
                    <div class="theTopBox">
                        <div class="theCityBox">
                            <div class="theCity" @click="showCitySelect">{{ currentPos }}</div>
                            <i class="icon iconfont iconBitmap1"></i>
                        </div>
                        <div class="theLine"></div>
                        <input type="text" placeholder="请输入协议单位代码" v-model="companyCode" class="theSearchKeyWord"
                            v-if="currentType == 'COMPANY'" placeholder-style="color:#CCCCCC" />
                        <div v-else class="theSearchKeyWordBox">
                            <div class="theSearchKeyWord limit" @click="toShowHotelFilter"
                                :class="{ 'empty': !positionDescript }">{{ positionDescript ? positionDescript :
                                placeholder }}</div>
                            <i v-if="positionDescript" class="icon iconfont iconweibiaoti-mn"
                                @click="clearSearchKeyWord"></i>
                        </div>
                        <i class="icon iconfont icondingwei1" @click="getCurrentPosition(false)"
                            :style="{ 'color': datas.textColor }"></i>
                    </div>
                </div>
                <div class="row oneline time" v-if="isOpenHotelIndexSamllTime == 'F'">
                    <div class="calendarBox" @click="showCalendar" v-if="otaChannel !== 'HOUR'">
                        <div class="timerBox">
                            <div class="timeDetails">
                                <p class="weekTime">{{ checkInTime }}</p>
                                <p class="dayTime" :style="{ 'color': datas.textColor }">{{ checkInDay }}</p>
                                <p class="monthDay">{{ checkInMonth }}</p>
                            </div>
                        </div>
                        <div class="timerMiddleBox">
                            <em class="line">共{{ zday }}晚</em>
                            <span class="dawnStartTips" v-if="isDawnRoom">0:00后入住</span>
                        </div>
                        <div class="timerBox">
                            <div class="timeDetails">
                                <p class="weekTime">{{ checkOutTime }}</p>
                                <p class="dayTime" :style="{ 'color': datas.textColor }">{{ checkOutDay }}</p>
                                <p class="monthDay">{{ checkOutMonth }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="calendarBox" @click="showCalendar" v-if="otaChannel == 'HOUR'">
                        <div class="timerBox">
                            <div class="timeDetails">
                                <p class="weekTime">{{ checkInTimeHOUR }}</p>
                                <p class="dayTime" :style="{ 'color': datas.textColor }">{{ checkInDayHOUR }}</p>
                                <p class="monthDay">{{ checkInMonthHOUR }}</p>
                            </div>
                        </div>
                        <div class="timerMiddleBox">
                            <div class="timerMiddleBox">
                                <div class="todayOnly">
                                    {{ isOpenHourChooseDay == 'F' ? '仅限今日' : '选择日期' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="smallMode oneline" v-else :class="{ isDawnRoom: isDawnRoom }">
                    <div class="smallTimeBox" @click="showCalendar" v-if="otaChannel !== 'HOUR'">
                        <div class="leftTime">
                            <div class="theTimeItem">
                                <div class="theTimeLeft">{{ timeFilterMD(fromDate) }}</div>
                                <div class="theTimeRight">{{ checkInTime }}</div>
                            </div>
                            <div class="middleTime">
                            </div>
                            <div class="theTimeItem">
                                <div class="theTimeLeft">{{ timeFilterMD(toDate) }}</div>
                                <div class="theTimeRight">{{ checkOutTime }}</div>
                            </div>
                        </div>
                        <div class="rightTime">
                            共{{ zday }}晚
                        </div>
                    </div>
                    <div class="smallTimeBox" @click="showCalendar" v-if="otaChannel == 'HOUR'">
                        <div class="leftTime">
                            <div class="theTimeItem">
                                <div class="theTimeLeft">{{ timeFilterMD(HOUR.fromDate) }}</div>
                            </div>
                        </div>
                        <div class="rightTime hour" v-if="isOpenHourChooseDay == 'F'"
                            :style="{ 'color': datas.textColor }">仅限今日</div>
                        <div class="rightTime hour" v-else :style="{ 'color': datas.textColor }">{{ checkInTimeHOUR }}<i
                                class="icon iconfont iconjiantou"></i></div>
                    </div>
                    <div class="theDawnTips" v-if="isDawnRoom">凌晨0:00入住，预订日期为前一日</div>
                </div>
                <!-- <div class="row oneline" @click="toShowPriceStarFilter" v-if="isOpenPriceStarSearch == 'T'">
                    <span class="searchKeyWord" :class="{ empty: !priceStarSearchDesc }">
                        {{ priceStarSearchDesc ? priceStarSearchDesc : '价格/星级' }}
                    </span>
                </div> -->
                <div class="row oneline" v-if="isOpenIndexForceCompanyBook == 'T'">
                    <input type="text" placeholder="请输入协议单位代码" v-model="companyCode" class="searchKeyWord"
                        placeholder-style="color:#CCCCCC" />
                </div>
                <div class="dawnTipsBox" v-if="isDawnRoom">
                    <p class="dawnTips">
                        凌晨房预定须知：预订当日0:00～06:00的房间，离店时间为预订当日12:00，具体时间请和酒店确认。
                    </p>
                </div>
                <div class="btn hotelBook" @click="gohotel" :class="datas.btStyle"
                    :style="{ 'backgroundColor': datas.btnColor, 'color': datas.btnTextColor }">
                    {{ hotelDescript }}预订
                </div>
                <p class="ensureDesc" v-if="bookIndexTips" :style="{ 'color': datas.textColor }" @click="showPricePlan">
                    <i class="icon iconfont iconrenzhengdunpaianquanbaozhangzhibao"></i>
                    {{ bookIndexTips }}
                </p>
            </div>
        </div>
        <calendar ref="calendar" @change-date="changeDate" :checkInDay="fromDate" :checkOutDay="toDate"></calendar>
        <city-select ref="citySelect" v-on:changeCity="changeCity" :currentCity="currentCity"
            :isOpenCountry="isOpenCountry" :onlySelf="onlySelf"></city-select>
        <hotel-filter ref="hotelFilter" v-on:shaiXuanSearch="shaiXuanSearch" v-on:clearShaixuan="clearShaixuan"
            v-bind:city-code="cityCode" v-bind:city-name="cityName" v-bind:ota-channel="otaChannel"
            v-bind:from-date="fromDateNew" v-bind:toDate="toDateNew" v-bind:placeholder="placeholder"
            fullScreen="T"></hotel-filter>
        <price-star-search ref="priceStarSearch" @priceStarSearch="priceStarSearch"></price-star-search>
        <price-info ref="priceInfo" :datas="datas"></price-info>
    </div>
</template>

<script>
import api from '@/utils/api'
import { jAlert3, jAlert5 } from '@/base/jAlert/jAlert'
import { setStorage, getStorage } from '@/utils/wxuser'
import moment from 'moment'
import coordtransform from 'coordtransform'
import calendar from '@/components/hotel/calendar/calendar'
import { urlEncode } from '@/utils/index'
import citySelect from '@/components/hotel/citySelect/citySelect'
import hotelFilter from '@/components/hotel/hotelFilter/hotelFilter'
import priceInfo from "@/components/priceInfo";
/* import priceStarSearch from "../components/priceStarSearch"; */

var config = {}
export default {
    props: ['datas'],
    data() {
        return {
            cityName: '',
            cityCode: '',
            clientLatitude: '',
            clientLongitude: '',
            otaChannel: 'WECHAT',
            position: '',
            positionValue: '',
            keyWord: '',
            radius: '',
            positionDescript: '',
            currentCity: {
                cityName: '',
                cityCode: '',
                clientLatitude: '',
                clientLongitude: ''
            },
            hotelDescript: '酒店',
            fromDate: moment().format('YYYY-MM-DD'),
            toDate: moment().add(1, 'days').format('YYYY-MM-DD'),
            channels: [
                {
                    name: '全日房',
                    otaChannel: 'WECHAT',
                    type: 'NORMAL'
                }
            ],
            HOUR: {
                fromDate: moment().format('YYYY-MM-DD'),
                toDate: moment().format('YYYY-MM-DD')
            },
            isOpenHotelIndexSamllTime: "F",
            isOpenCountry: false,
            hasAddress: 'F',
            isOpenMidNight: 'F',
            isCloseHourRoom: 'F',
            isOpenCompanyBookIndex: 'F',
            currentType: 'NORMAL',
            companyCode: "",
            bookIndexTips: '',
            currentChannelIndex: 0,
            isOpenIndexForceCompanyBook: 'F',
            isOpenHourChooseDay: 'F',
            isChoosedDawnRoom: 'F',
            isOpenPriceStarSearch: "F",
            priceStarSearchDesc: "",
            price: "",
            level: "",
            onlySelf: "",
            loaded: false,
            whiteSpace: 12,
            pageType: "",
        }
    },
    mounted() {
        this.otaChannel = 'WECHAT'
        this.channels[0].otaChannel = 'WECHAT'
        this.rememberCity()
        this.getCurrentPosition(true)
        this.getfunctionControl()
        this.$refs.calendar.init({
            checkInDay: this.fromDate,
            checkOutDay: this.toDate
        })
        this.initData();
    },
    created() {
        config = getStorage('config')
    },
    beforeDestroy() {
        this.isShowDialog = false
    },
    components: {
        calendar,
        citySelect,
        hotelFilter,
        priceInfo,
        /* priceStarSearch, */
    },
    methods: {
        showPricePlan(){
            if(this.datas.isOpenPricePlan == 'T'&&this.datas.pricePlan){
               this.$refs.priceInfo.show();
            }
        },
        clearSearchKeyWord() {
            this.$refs.hotelFilter.reset();
        },
        priceStarSearch(data) {
            this.price = "";
            this.level = "";
            let priceStarSearchDescArr = [];
            let levelArr = []
            data.price.forEach((n) => {
                this.price = `${n.startPrice},${n.endPrice}`;
                priceStarSearchDescArr.push(n.desc);
            })
            data.star.forEach((n) => {
                levelArr.push(n.starCodeList.join(","));
                priceStarSearchDescArr.push(n.value);
            })
            this.level = levelArr.join(";");
            this.priceStarSearchDesc = priceStarSearchDescArr.join(",");
            console.log(this.priceStarSearchDesc)
        },
        toShowPriceStarFilter() {
            this.$refs.priceStarSearch.showDialog()
        },
        timeFilterMD (val){
            return moment(val).format("MM月DD日");
        },
        isDawn() {
            var rushBuyStartTime = 'YYYY-MM-DD 00:00'
            var rushBuyEndTime = 'YYYY-MM-DD 06:00'
            var startTime = moment().format(rushBuyStartTime)
            var endTime = moment().format(rushBuyEndTime)
            if (moment().isAfter(startTime) && moment().isBefore(endTime)) {
                jAlert5(
                    '您是否要今日凌晨入住',
                    () => {
                        this.fromDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
                        this.toDate = moment().format('YYYY-MM-DD')
                        this.$refs.calendar.init({
                            checkInDay: this.fromDate,
                            checkOutDay: this.toDate
                        })
                        this.isChoosedDawnRoom = 'T'
                    },
                    () => {
                        this.isChoosedDawnRoom = 'T'
                    }
                )
            }
        },
        toShowHotelFilter() {
            if (!this.cityCode) {
                jAlert3('请先选择城市')
                setTimeout(() => {
                    this.showCitySelect()
                }, 100)
                return false
            }
            this.$refs.hotelFilter.showDialog()
        },
        gohotel() {
            if (this.isOpenIndexForceCompanyBook == 'T' && !this.companyCode) {
                jAlert3('请输入协议代码')
                return false
            }
            if (this.currentType == 'COMPANY' && !this.companyCode) {
                jAlert3('请输入协议代码')
                return false
            }
            if (!this.cityCode && !this.isOpenCountry) {
                jAlert3('请先选择城市')
                setTimeout(() => {
                    this.showCitySelect()
                }, 100)
                return false
            }
            if (!this.cityCode) {
                this.radius = ''
            }
            var params = {
                fromDate: this.fromDate,
                toDate: this.toDate,
                cityName: this.cityName,
                cityCode: this.cityCode,
                clientLatitude: '',
                clientLongitude: '',
                otaChannel: this.otaChannel,
                position: this.position,
                positionValue: this.positionValue,
                keyWord: this.keyWord,
                radius: this.radius,
                positionDescript: this.positionDescript,
                hasAddress: this.hasAddress,
                distributorId: this.distributorId,
                isDawnRoom: this.isDawnRoom,
                isChoosedDawnRoom: this.isChoosedDawnRoom,
                onlySelf: this.onlySelf,
                price: this.price,
                level: this.level,
            }
            if (
                this.currentCity.cityCode == this.cityCode &&
                !this.positionDescript
            ) {
                params.clientLatitude = this.currentCity.clientLatitude
                params.clientLongitude = this.currentCity.clientLongitude
                params.hasAddress = 'T'
            }
            if (params.positionDescript) {
                params.orderDistance = 'asc'
            } else {
                if (this.orderSortType) {
                    if (this.orderSortType == 'orderDistance') {
                        params.orderDistance = 'asc'
                    }
                    if (this.orderSortType == 'orderPrice') {
                        params.orderPrice = 'asc'
                    }
                    if (this.orderSortType == 'orderScore') {
                        params.orderBySql = 'score desc'
                    }
                } else {
                    params.orderDistance = ''
                }
            }
            if (this.currentType == 'COMPANY') {
                params.companyCode = this.companyCode
            }
            if (this.otaChannel == 'HOUR') {
                params.fromDate = this[this.otaChannel].fromDate
                params.toDate = this[this.otaChannel].toDate
            }
            if (this.isOpenIndexForceCompanyBook == 'T') {
                params.companyCode = this.companyCode
            }
            window.location.href = `${window.location.origin}/wechat/#/hotelListNew?${urlEncode(params)}`
        },
        goCurrentHotel() {
            if (this.isOpenIndexForceCompanyBook == 'T' && !this.companyCode) {
                jAlert3('请输入协议代码')
                return false
            }
            if (this.currentType == 'COMPANY' && !this.companyCode) {
                jAlert3('请输入协议代码')
                return false
            }
            var params = {
                fromDate: this.fromDate,
                toDate: this.toDate,
                cityName: this.currentCity.cityName,
                cityCode: this.currentCity.cityCode,
                clientLatitude: this.currentCity.clientLatitude,
                clientLongitude: this.currentCity.clientLongitude,
                otaChannel: this.otaChannel,
                position: '',
                positionValue: '',
                keyWord: '',
                radius: '',
                positionDescript: '',
                keyWord: '',
                hasAddress: 'T',
                distributorId: this.distributorId,
                orderDistance: 'asc',
                isDawnRoom: this.isDawnRoom,
                isChoosedDawnRoom: this.isChoosedDawnRoom,
                onlySelf: this.onlySelf,
                price: this.price,
                level: this.level,
            }
            if (this.currentType == 'COMPANY') {
                params.companyCode = this.companyCode
            }
            if (this.otaChannel == 'HOUR') {
                params.fromDate = this[this.otaChannel].fromDate
                params.toDate = this[this.otaChannel].toDate
            }
            if (this.isOpenIndexForceCompanyBook == 'T') {
                params.companyCode = this.companyCode
            }
            window.location.href = `${window.location.origin}/wechat/#/hotelListNew?${urlEncode(params)}`
        },
        changeDate(time) {
            if (this.otaChannel == 'HOUR') {
                this[this.otaChannel].fromDate = time.checkInDay
                this[this.otaChannel].toDate = time.checkOutDay
                return false
            }
            this.fromDate = time.checkInDay
            this.toDate = time.checkOutDay
        },
        showCalendar() {
            if (this.otaChannel == 'HOUR' && this.isOpenHourChooseDay == 'F') {
                jAlert3('仅限今日')
                return
            }
            if (this.otaChannel == 'HOUR') {
                this.$refs.calendar.init({
                    checkInDay: this[this.otaChannel].fromDate,
                    checkOutDay: this[this.otaChannel].toDate,
                    type: 'single'
                })
            } else {
                this.$refs.calendar.init({
                    checkInDay: this.fromDate,
                    checkOutDay: this.toDate
                })
            }
            this.$refs.calendar.showDialog()
        },
        showCitySelect() {
            this.$refs.citySelect.showDialog()
        },
        changeCity(data) {
            this.$refs.citySelect.hideDialog()
            this.address = ''
            this.keyWord = ''
            this.cityName = data.descript
            this.cityCode = data.code
        },
        rememberCity() {
            this.cityName = getStorage('cityName')
            this.cityCode = getStorage('cityCode')
        },
        getCurrentPosition(boolean) {
            if (!this.currentCity.cityCode) {
                this.requireCurrentPosition(boolean)
            } else {
                if (!boolean) {
                    this.goCurrentHotel()
                }
            }
        },
        requireCurrentPosition(boolean) {
            var self = this;
            /* let thirdPartyChannel = getStorage("thirdPartyChannel")||"";
            if(thirdPartyChannel=='yxy'){
                var googlezb = coordtransform.wgs84togcj02(Number(getStorage('longitude')), Number(getStorage('latitude')));
                var baiduzb = coordtransform.gcj02tobd09(googlezb[0], googlezb[1]);
                var latitude = Number(baiduzb[1]);
                var longitude = Number(baiduzb[0]);
                self.getCityCode(latitude, longitude, boolean);
                return false;
            } */
            wx.ready(function () {
                wx.getLocation({
                    type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    success: function (res) {
                        var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                        var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                        var baiduzb = coordtransform.gcj02tobd09(longitude,latitude);
                        latitude = Number(baiduzb[1]);
                        longitude = Number(baiduzb[0]);
                        self.getCityCode(latitude, longitude, boolean);
                    }
                });
            });
        },
        getCityCode(latitude, longitude, boolean) {
            var self = this
            var city = ''
            api
                .getCityinfo({
                    latitude: latitude,
                    longitude: longitude
                })
                .then((res) => {
                    if (!res) {
                        return false
                    }
                    if (typeof res !== 'object') {
                        var res = JSON.parse(res)
                    }
                    if (
                        !(
                            res &&
                            res.result &&
                            res.result.addressComponent &&
                            res.result.addressComponent.city
                        )
                    ) {
                        return false
                    }
                    city = res.result.addressComponent.city
                    var index = city.indexOf('市')
                    if (index > -1) {
                        city = city.substring(0, index)
                    }
                    if (city.indexOf('地区') > -1) {
                        var index2 = city.indexOf('地区')
                        city = city.substring(0, index2)
                    }
                    return api.findCityCodeByDes({
                        descript: city,
                        hotelGroupCode: config.hotelGroupCode
                    })
                })
                .then((cityInfo) => {
                    if (cityInfo.result == 1) {
                        self.currentCity.cityName = city
                        self.currentCity.cityCode = cityInfo.retVal.resultInfo
                        self.currentCity.clientLatitude = latitude
                        self.currentCity.clientLongitude = longitude
                        if (!(self.cityName && self.cityCode)) {
                            self.cityName = city
                            self.cityCode = cityInfo.retVal.resultInfo
                        }
                        if (!boolean) {
                            self.goCurrentHotel()
                        }
                    } else {
                        jAlert3('您所在的城市暂无本集团酒店，敬请期待！')
                    }
                })
        },
        shaiXuanSearch(data) {
            this.clientLatitude = data.clientLatitude
            this.clientLongitude = data.clientLongitude
            this.keyWord = data.keyWord
            this.position = data.position
            this.positionDescript = data.positionDescript
            this.positionValue = data.positionValue
            this.radius = data.radius
            this.hasAddress = data.hasAddress
        },
        changeChannel(item, index) {
            this.otaChannel = item.otaChannel
            this.currentType = item.type
            this.currentChannelIndex = index
        },
        getfunctionControl() {
            var self = this
            var codes = [
                'isOpenCountry',
                'defaultCity',
                'hotelDescript',
                'isCloseHourRoom',
                'bookIndexTips',
                'isOpenIndexForceCompanyBook',
                'isOpenHourChooseDay',
            ]
            var params = {
                appid: config.appid,
                codes: codes.join(','),
                componentAppid: config.componentAppid,
                hotelCode: config.hotelCode ? config.hotelCode : 0,
                hotelGroupCode: config.hotelGroupCode,
                clientType: 'wechat'
            }
            api
                .getMultiSysOptionCommon(params)
                .then((data) => {
                    data.retVal.forEach(function (n, i) {
                        if (n.code == 'isOpenCountry') {
                            self.isOpenCountry = n.value == 'F' ? false : true
                        }
                        if (n.code == 'defaultCity') {
                            if (n.value && n.value.indexOf(',') > -1) {
                                if (!self.cityCode) {
                                    self.cityName = n.value.split(',')[0]
                                    self.cityCode = n.value.split(',')[1]
                                }
                            }
                        }
                        if (n.code == 'hotelDescript') {
                            self.hotelDescript = n.value
                        }
                        if (n.code == 'isOpenMidNight') {
                            self.isOpenMidNight = n.value
                            if (self.isOpenMidNight == 'T') {
                                self.isDawn()
                            }
                        }
                        if (n.code == 'bookIndexTips' && n.value) {
                            self.bookIndexTips = n.value
                        }
                        if (n.code == 'isOpenIndexForceCompanyBook' && n.value) {
                            self.isOpenIndexForceCompanyBook = n.value
                        }
                        if (n.code == 'isOpenHourChooseDay' && n.value) {
                            self.isOpenHourChooseDay = n.value
                        }
                    })
                    if (!self.hotelDescript) {
                        self.hotelDescript = '酒店'
                    }
                    if (!self.bookIndexTips) {
                        self.bookIndexTips = '官方渠道预订享低价保证'
                    }
                    setStorage('hotelDescript', self.hotelDescript)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        initData() {
            if (this.datas.dateRange > 0) {
                setStorage('calendarDays', Number(this.datas.dateRange))
                this.$refs.calendar.init({
                    checkInDay: this.fromDate,
                    checkOutDay: this.toDate
                })
            }
            if (this.datas.isCloseHourRoom == "F") {
                this.channels.push({
                    name: '时租房',
                    otaChannel: 'HOUR',
                    type: 'HOUR'
                })
            }
            if (this.datas.isOpenCompanyBookIndex == 'T') {
                this.channels.push({
                    name: '企业预订',
                    otaChannel: 'WECHAT',
                    type: 'COMPANY'
                })
            }
            if (this.datas.isOpenPriceStarSearch == 'T') {
                this.isOpenPriceStarSearch = "T";
                if (this.isOpenPriceStarSearch == "T") {
                    //this.$refs.priceStarSearch.init();
                }
            }
            if (this.datas.isOpenHotelIndexSamllTime) {
                this.isOpenHotelIndexSamllTime = this.datas.isOpenHotelIndexSamllTime;
            }
            this.whiteSpace = Number(this.datas.whiteSpace);
            this.loaded = true;
        }
    },
    watch: {
    },
    computed: {
        checkInDayHOUR() {
            return moment(this.HOUR.fromDate).format('DD')
        },
        checkInTimeHOUR() {
            const today = moment();
            const tomorrow = moment().add(1, 'days');
            const dayAfterTomorrow = moment().add(2, 'days');
            const inputDate = moment(this.HOUR.fromDate);
            if (inputDate.isSame(today, 'day')) {
                return '今天';
            } else if (inputDate.isSame(tomorrow, 'day')) {
                return '明天';
            } else if (inputDate.isSame(dayAfterTomorrow, 'day')) {
                return '后天';
            } else {
                return inputDate.format('dddd');
            }
        },
        checkInMonthHOUR() {
            return moment(this.HOUR.fromDate).format('YYYY / MM')
        },
        checkInDay() {
            return moment(this.fromDate).format('DD')
        },
        checkOutDay() {
            return moment(this.toDate).format('DD')
        },
        checkInTime() {
            const today = moment();
            const tomorrow = moment().add(1, 'days');
            const dayAfterTomorrow = moment().add(2, 'days');
            const inputDate = moment(this.fromDate);
            if (inputDate.isSame(today, 'day')) {
                return '今天';
            } else if (inputDate.isSame(tomorrow, 'day')) {
                return '明天';
            } else if (inputDate.isSame(dayAfterTomorrow, 'day')) {
                return '后天';
            } else {
                return inputDate.format('dddd');
            }
        },
        checkOutTime() {
            const today = moment();
            const tomorrow = moment().add(1, 'days');
            const dayAfterTomorrow = moment().add(2, 'days');
            const inputDate = moment(this.toDate);
            if (inputDate.isSame(today, 'day')) {
                return '今天';
            } else if (inputDate.isSame(tomorrow, 'day')) {
                return '明天';
            } else if (inputDate.isSame(dayAfterTomorrow, 'day')) {
                return '后天';
            } else {
                return inputDate.format('dddd');
            }
        },
        checkInMonth() {
            return moment(this.fromDate).format('YYYY / MM')
        },
        checkOutMonth() {
            return moment(this.toDate).format('YYYY / MM')
        },
        zday() {
            let arr = moment(this.fromDate)
            let dep = moment(this.toDate)
            let zday = dep.diff(arr, 'd')
            return zday
        },
        currentPos() {
            if (this.cityName) {
                return this.cityName
            } else {
                if (this.isOpenCountry) {
                    return '全国'
                } else {
                    return '城市'
                }
            }
        },
        placeholder() {
            return `关键字/商圈/${this.hotelDescript}`
        },
        isDawnRoom() {
            return (
                this.fromDate == moment().subtract(1, 'days').format('YYYY-MM-DD')
            )
        },
        fromDateNew() {
            let fromDate = this.fromDate
            if (this.otaChannel == 'HOUR') {
                fromDate = this.HOUR.fromDate
            }
            return fromDate
        },
        toDateNew() {
            let toDate = this.toDate
            if (this.otaChannel == 'HOUR') {
                toDate = this.HOUR.toDate
            }
            return toDate
        }
    },
}
</script>
<style lang="less">
@import url('~@/styles/mixin.less');

.ui_hotelBook {
    .hotel_search {
        width: 351px;
        border-radius: 4px;
        background-size: 100% 100%;
        margin: 0 auto;
        box-sizing: border-box;

        &.shadow {
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.15);
        }

        .smallMode {
            position: relative;

            &.isDawnRoom {
                .smallTimeBox {
                    height: auto;
                    margin-top: 15px;
                }
            }

            .theDawnTips {
                font-size: 12px;
                color: #FE5101;
                margin-top: 4px;
                padding-bottom: 15px;
            }
        }

        .smallTimeBox {
            height: 54px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .leftTime {
                display: flex;
                height: 100%;
                align-items: center;

                .middleTime {
                    width: 22px;
                    position: relative;

                    &::after {
                        content: "";
                        height: 1px;
                        width: 7px;
                        background: #CCCCCC;
                        position: absolute;
                        left: 7px;
                    }
                }

                .theTimeItem {
                    display: flex;
                    height: 100%;
                    align-items: center;

                    .theTimeLeft {
                        font-size: 17px;
                        color: #111111;
                    }

                    .theTimeRight {
                        font-size: 14px;
                        color: #111111;
                        margin-left: 1.5px;
                    }
                }
            }

            .rightTime {
                font-size: 14px;
                color: #111111;

                &.hour {
                    color: @color-theme;
                    display: flex;
                    align-items: center;
                    line-height: 1;

                    .iconfont {
                        margin-left: 3px;
                    }
                }

                &.hour2 {
                    position: relative;
                    color: @color-theme;
                    padding-right: 10px;

                    &::after {
                        border-right: 1px solid @color-theme;
                        border-top: 1px solid @color-theme;
                        left: calc(~"100% + 10px");
                        top: 10px;
                    }
                }
            }
        }

        .switchChannel {
            height: 43px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            //overflow: hidden;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            background-image: linear-gradient(180deg, rgba(239, 241, 244, 0.94) 0%, #EFF1F4 100%);

            .channel {
                height: 100%;
                flex: 1;
                line-height: 43px;
                text-align: center;
                background: transparent;
                font-size: 17px;
                color: #1E1E1E;
                z-index: 1;

                &.active {
                    color: @color-theme;
                }
            }

            .selectChannel {
                position: absolute;
                width: 50%;
                background: #fff;
                height: 48px;
                left: 0;
                transition: all 0.3s;
                transform: translateX(0);
                bottom: -1px;
                background-color: #fff;
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;

                &.third {
                    width: 33.33333%;
                }

                &.left {
                    border-top-left-radius: 0px;

                    &:before {
                        left: -24px;
                        content: '';
                        position: absolute;
                        bottom: 0px;
                        background-image: url(https://xcx.ihotel.cn/hotel/images/roomIndexL.png);
                        background-size: 100%;
                        width: 24px;
                        height: 48px;
                        background-position: left top;
                    }
                }

                &.right {
                    border-top-right-radius: 0px;

                    &:after {
                        right: -24px;
                        content: '';
                        position: absolute;
                        bottom: 0px;
                        background-image: url(https://xcx.ihotel.cn/hotel/images/roomIndexR.png);
                        background-size: 100%;
                        width: 24px;
                        height: 48px;
                        background-position: left top;
                    }
                }
            }
        }

        &.top30 {
            margin-top: 30px;
        }

        .rowWrapper {
            padding: 0 20px;
            background: #fff;
            border-radius: 0px 0px 8px 8px;

            &.radius {
                border-radius: 6px;
            }
        }

        .row {
            height: 62px;
            display: flex;
            align-items: center;
            position: relative;

            .theTopBox {
                display: flex;
                align-items: center;
                height: 100%;
                justify-content: space-between;
                width: 100%;

                .icondingwei1 {
                    color: @color-theme;
                    font-size: 19px;
                }

                .theCityBox {
                    display: flex;
                    align-items: center;
                    color: #333333;
                    height: 100%;

                    .theCity {
                        max-width: 70px;
                        .textHidden();
                        font-size: 17px;
                    }

                    .iconfont {
                        margin-left: 8px;
                        font-size: 8px;
                    }
                }

                .theLine {
                    margin: 0 10px;
                    height: 31px;
                    width: 1px;
                    background-color: #eee;
                }

                .theSearchKeyWordBox {
                    flex: 1;
                    display: flex;
                    align-items: center;

                    .iconfont {
                        font-size: 14px;
                        color: #999;
                        margin-right: 10px;
                        margin-left: 8px;
                    }
                }

                .theSearchKeyWord {
                    flex: 1;
                    color: #333333;
                    font-size:14px;
                    .textHidden();

                    &.empty {
                        color: #CCCCCC;
                    }

                    &.limit {
                        width: 153px;
                    }
                }
            }

            &.time {
                height: 111px;
            }

            .tagName {
                font-size: @font-size-medium-x;
                color: @color-font;
            }

            .cityName {
                flex: 1;
                font-size: @font-size-medium-x;
                color: @color-font;
                text-indent: 15px;
            }

            .location {
                width: 90px;
                display: flex;
                align-items: center;
                font-size: @font-size-medium;
                text-indent: 2px;
                color: @color-font;

                i {
                    margin-right: 5px;
                    color: @color-theme;
                }

                .em {
                    width: 1px;
                    height: 24px;
                    background: @color-border;
                    margin-right: 8px;
                    position: relative;
                    top: 2px;
                }
            }

            .hotelSelect {
                font-size: @font-size-medium;
                color: @color-font;
            }

            .searchKeyWord {
                font-size: 17px;
                color: @color-font;
                width: 100%;

                &.empty {
                    color: #CCCCCC;
                }
            }

            .calendarBox {
                flex: 1;
                display: flex;
                align-items: center;
                height: 100%;

                .timerBox {
                    width: 70px;

                    .timeDetails {
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        .dayTime {
                            font-size: 30px;
                            color: @color-theme;
                            font-family: @price-font-family;
                        }

                        .weekTime {
                            font-size: 14px;
                            color: #666666;
                        }

                        .monthDay {
                            font-size: 14px;
                            color: #111111;
                        }
                    }
                }

                .timerMiddleBox {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    position: relative;

                    .todayOnly {
                        height: 100%;
                        width: 100%;
                        text-align: right;
                        font-size: 15px;
                        color: #666666;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        margin-right: 50px;
                    }

                    .line {
                        font-size: 14px;
                        color: #333333;
                        position: relative;

                        &:after {
                            content: '';
                            position: absolute;
                            width: 10px;
                            height: 1px;
                            background-color: #e6e6e6;
                            top: 10px;
                            left: -20px;
                        }

                        &:before {
                            content: '';
                            position: absolute;
                            width: 10px;
                            height: 1px;
                            background-color: #e6e6e6;
                            top: 10px;
                            right: -20px;
                        }
                    }

                    .dawnStartTips {
                        position: absolute;
                        font-size: 11px;
                        color: #666666;
                        bottom: 15px;
                    }
                }
            }
        }

        .hotelBook {
            height: 44px;
            line-height: 44px;
            background: @color-theme;
            border-radius: 8px;
            font-size: 17px;
            color: #ffffff;
            text-align: center;
            margin-top: 20px;

            &.straight {
                border-radius: 0px;
            }
        }

        .ensureDesc {
            display: flex;
            color: @color-theme;
            font-size: @font-size-tiny;
            height: 50px;
            align-items: center;
            justify-content: center;

            .iconfont {
                font-size: 16px;
                margin-right: 5px;
                position: relative;
                top: 1px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/hotelBook.vue